var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.442,
    height: 121.903,
    viewBox: "0 0 86.442 121.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activeUsers",
    transform: "translate(534.549 78.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13850",
    "data-name": "Group 13850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-517.937,20.923h-7.871c-.159-.007-.322-.019-.5-.039a8.615,8.615,0,0,1-5.82-3.188,8.609,8.609,0,0,1-1.86-6.371A21.818,21.818,0,0,1-530.065-1.07a33.51,33.51,0,0,1,9.857-9.269,50.874,50.874,0,0,1,12.923-5.808,47.438,47.438,0,0,1,13.122-2.011h5.332A48.631,48.631,0,0,1-475.5-16.147a51.17,51.17,0,0,1,13.03,5.808,33.5,33.5,0,0,1,9.9,9.269,21.8,21.8,0,0,1,3.933,12.395v.356c.009.11.016.225.021.338a8.5,8.5,0,0,1-2.255,6.15,8.5,8.5,0,0,1-5.943,2.754H-464.7a26.474,26.474,0,0,0-2.092-10.361,26.548,26.548,0,0,0-5.7-8.461A26.562,26.562,0,0,0-480.952-3.6,26.456,26.456,0,0,0-491.313-5.7,26.457,26.457,0,0,0-501.675-3.6,26.54,26.54,0,0,0-510.136,2.1a26.515,26.515,0,0,0-5.7,8.461,26.438,26.438,0,0,0-2.092,10.361Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M-491.316-18.165a20.141,20.141,0,0,0,15.287-6.4,45.258,45.258,0,0,0,9.6-29.16,24.9,24.9,0,0,0-25.364-24.418A24.9,24.9,0,0,0-516.21-53.725a46.549,46.549,0,0,0,9.6,29.481A21.189,21.189,0,0,0-491.316-18.165Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14040",
    "data-name": "Group 14040"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_704",
    "data-name": "Ellipse 704",
    cx: 21.726,
    cy: 21.726,
    r: 21.726,
    transform: "translate(-513.051 -0.696)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11193",
    "data-name": "Path 11193",
    d: "M-478.5,9.787l1.857,1.857a1.574,1.574,0,0,1,0,2.225l-18.4,18.4a1.575,1.575,0,0,1-2.226,0l-8.737-8.737a1.575,1.575,0,0,1,0-2.226l1.855-1.855a1.574,1.574,0,0,1,2.225,0l5.768,5.768,15.436-15.436A1.572,1.572,0,0,1-478.5,9.787Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/activeUsers.41ae2dee4bedc3648a9cced9d49cc823.svg";
export { ForwardRef as ReactComponent };